import { migrateFullBorderType } from 'tools/commands/migrate/utils/migrateUtils'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'

const PADDING_LEFT = 3
const PADDING_RIGHT = 1
const PADDING_TOP = 0
const PADDING_BOTTOM = 2

const migratePadding = (
  newEntity: PopupInterface,
  originalEntity: OldEntityInterface,
) => {
  if (typeof originalEntity?.styles?.padding === 'undefined') {
    // do nothing
  } else {
    const desktopSplittedPadding = originalEntity.styles.padding.split(' ')

    const shortPaddingRecord = desktopSplittedPadding.length === 1
    if (shortPaddingRecord) {
      newEntity.padding = {
        paddingTop: desktopSplittedPadding[0],
        paddingBottom: desktopSplittedPadding[0],
        paddingLeft: desktopSplittedPadding[0],
        paddingRight: desktopSplittedPadding[0],
      }
    } else {
      newEntity.padding = {
        paddingTop: desktopSplittedPadding[PADDING_TOP]
          ? parseInt(desktopSplittedPadding[PADDING_TOP], 10)
          : 0,
        paddingRight: desktopSplittedPadding[PADDING_RIGHT]
          ? parseInt(desktopSplittedPadding[PADDING_RIGHT], 10)
          : 0,
        paddingBottom: desktopSplittedPadding[PADDING_BOTTOM]
          ? parseInt(desktopSplittedPadding[PADDING_BOTTOM], 10)
          : 0,
        paddingLeft: desktopSplittedPadding[PADDING_LEFT]
          ? parseInt(desktopSplittedPadding[PADDING_LEFT], 10)
          : 0,
      }
    }
  }

  if (!originalEntity.mobileStyles) {
    return
  }

  // MOBILE PADDING
  if (typeof originalEntity?.mobileStyles?.padding === 'undefined') {
    // do nothing
  } else {
    const mobileSplitPadding = originalEntity.mobileStyles.padding.split(' ')

    const shortPaddingRecord = mobileSplitPadding.length === 1
    if (shortPaddingRecord) {
      newEntity.mobilePadding = {
        paddingTop: mobileSplitPadding[0],
        paddingBottom: mobileSplitPadding[0],
        paddingLeft: mobileSplitPadding[0],
        paddingRight: mobileSplitPadding[0],
      }
    } else {
      newEntity.mobilePadding = {
        paddingTop: mobileSplitPadding[PADDING_TOP]
          ? parseInt(mobileSplitPadding[PADDING_TOP], 10)
          : 0,
        paddingRight: mobileSplitPadding[PADDING_RIGHT]
          ? parseInt(mobileSplitPadding[PADDING_RIGHT], 10)
          : 0,
        paddingBottom: mobileSplitPadding[PADDING_BOTTOM]
          ? parseInt(mobileSplitPadding[PADDING_BOTTOM], 10)
          : 0,
        paddingLeft: mobileSplitPadding[PADDING_LEFT]
          ? parseInt(mobileSplitPadding[PADDING_LEFT], 10)
          : 0,
      }
    }
  }
}

export function migratePopup(entity: OldEntityInterface) {
  const popup: PopupInterface = {} as PopupInterface

  popup.id = entity.id
  popup.type = EntityTypeEnum.Popup
  popup.htmlAttrId = entity.options.attrId
  popup.childIds = entity.childIds || []

  popup.title = entity.options?.title || 'Popup'

  if (entity.styles.width) {
    popup.width = entity.styles.width
  }

  if (entity.options.delay) {
    popup.delay = entity.options.delay
  }

  if (entity.options.mobileDelay) {
    popup.mobileDelay = entity.options.mobileDelay
  }

  if (entity.options.showClose) {
    popup.showClose = Boolean(parseInt(entity.options.showClose))
  }

  if (entity.options.openAutomatically) {
    popup.openAutomatically = Boolean(
      parseInt(entity.options.openAutomatically),
    )
  }

  if (entity.options.openOnMobileAutomatically) {
    popup.openOnMobileAutomatically = Boolean(
      parseInt(entity.options.openOnMobileAutomatically),
    )
  }

  if (entity.options.openOnExit) {
    popup.openOnExit = Boolean(parseInt(entity.options.openOnExit))
  }

  if (entity.options.closedDays) {
    popup.closedDays = entity.options.closedDays
  }

  if (entity.styles.color) {
    popup.closeButtonColor = entity.styles.color
  }

  if (entity.mobileStyles.color) {
    popup.closeButtonMobileColor = entity.mobileStyles.color
  }

  // styles
  // border
  migrateFullBorderType(popup, entity)

  // paddings
  migratePadding(popup, entity)

  // background color
  if (entity.styles.backgroundColor) {
    popup.background = entity.styles.backgroundColor
  }

  if (entity.mobileStyles.backgroundColor) {
    popup.mobileBackground = entity.mobileStyles.backgroundColor
  }

  // box shadow
  if (entity.styles.boxShadow) {
    popup.boxShadow = entity.styles.boxShadow
  }

  if (entity.mobileStyles.boxShadow) {
    popup.mobileBoxShadow = entity.mobileStyles.boxShadow
  }

  return popup
}
